import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-workflow-navigation',
  templateUrl: './workflow-navigation.component.html',
  styleUrls: ['./workflow-navigation.component.scss']
})
export class WorkflowNavigationComponent implements OnInit {

  sections: any[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<WorkflowNavigationComponent>) { }

  ngOnInit() {
    this.sections = this.data.sections;
  }

  selectSection(section) {
    this.dialogRef.close(section)
  }

}



// WEBPACK FOOTER //
// ./src/app/workflows/workflow-navigation.component.ts